import * as React from 'react';

import styled from '../../theme';
import HighlightedClients from './HighlightedClients';
import Awards from './Awards';
import Press from './Press';

const Container = styled.div`
  background-color: #f0c491;
  color: #7c4b14;

  padding: 20px 40px;

  @media (min-width: ${props => props.theme.aboutBreakpoint}px) {
    padding: 60px 0;
  }

  a {
    color: #7c4b14;
    transition: 0.2s ease-in-out transform;

    &:hover {
      transform: translateX(10px);
    }
  }
`;

const Inner = styled.div`
  max-width: 960px;
  margin: 0 auto;

  > * {
    padding: 20px 0;
  }

  @media (min-width: 1800px) {
    font-size: 0.8vw;
  }
`;

class FlexZone extends React.Component {
  render() {
    return (
      <Container>
        <Inner>
          <HighlightedClients />
          <Awards />
          <Press />
        </Inner>
      </Container>
    );
  }
}

export default FlexZone;



// WEBPACK FOOTER //
// ./src/scenes/About/FlexZone.tsx